// Корзина строки редактируемого списка (бейджи, кнопки). Разметка была слово в слово
// продублирована в двух формах — вынесена, чтобы hover-состояние и размер иконки жили
// в одном месте.
import { Trash2 } from 'lucide-react'

interface Props {
  /** Что именно удаляем — попадает в aria-label («Удалить бейдж»). */
  label: string
  onClick: () => void
}

export const RemoveItemButton = ({ label, onClick }: Props) => (
  <button
    type="button"
    aria-label={label}
    onClick={onClick}
    className="rounded p-1.5 text-muted-foreground transition-colors hover:bg-destructive/10 hover:text-destructive"
  >
    <Trash2 className="h-3.5 w-3.5" />
  </button>
)
